import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

export default class Carousel {
    constructor(el, app) {
        this.el = el;
        this.app = app; // Keep reference to App
        this.slides = this.el.querySelectorAll('.swiper-slide');
        this.slidesCount = this.slides.length;
        this.swiperInstance = null;

        this.options = {
            loop: false,
            centeredSlides: false,
            slidesPerView: 1.1,
            spaceBetween: 10,
            speed: 900,
            grabCursor: true,
            navigation: {
                nextEl: this.el.querySelector('.slider-button-next'),
                prevEl: this.el.querySelector('.slider-button-prev'),
            },
            breakpoints: {
                768: {
                    centeredSlides: true,
                    slidesPerView: 'auto',
                    loop: true,
                },
            },
        };

        this.staticCasesEnabled = this.el.dataset.staticCases !== 'false';
        this.tabletDownOnly = 'stats' in this.el.dataset || 'relatedCards' in this.el.dataset;
        this.tabletBreakpoint = 1024;
        this.mediaQuery = null;
        this.boundHandleBreakpointChange = this.handleBreakpointChange.bind(this);

        this.init();
    }

    init() {
        this.setOptions();

        if (this.tabletDownOnly) {
            this.mediaQuery = window.matchMedia(`(max-width: ${this.tabletBreakpoint - 1}px)`);
            if (this.mediaQuery.matches) {
                this.initSwiper();
            }
            this.mediaQuery.addEventListener('change', this.boundHandleBreakpointChange);
            return;
        }

        if (this.staticCasesEnabled) {
            this.handleStaticCases();
        }

        if (this.options.enabled !== false) {
            this.initSwiper();
        }
    }

    handleBreakpointChange() {
        if (!this.tabletDownOnly || !this.mediaQuery) return;

        if (this.mediaQuery.matches) {
            this.initSwiper();
        } else {
            this.destroySwiper();
        }
    }

    initSwiper() {
        if (this.swiperInstance) return;

        if (this.staticCasesEnabled) {
            this.handleStaticCases();
        }

        if (this.options.enabled !== false) {
            this.swiperInstance = new Swiper(this.el, this.options);
        }
    }

    destroySwiper() {
        if (!this.swiperInstance) return;

        this.swiperInstance.destroy(true, true);
        this.swiperInstance = null;
    }

    setOptions() {
        // Swiper does not support `enabled` in breakpoints. For stats and relatedCards,
        // we skip creating Swiper on desktop (>= tabletBreakpoint) in init() so the CSS grid can take over.
        if ('stats' in this.el.dataset) {
            this.options.breakpoints = {
                320: {},
                1024: {},
            };
        }
        if ('relatedCards' in this.el.dataset) {
            this.options.breakpoints = {
                320: {},
                1024: {},
            };
            this.options.slidesPerView = 1.2;
        }
    }

    handleStaticCases() {
        if (window.innerWidth < 768) return;

        if (this.slidesCount <= 3) {
            // Disable Swiper
            this.options.enabled = false;

            // Hide navigation
            this.hideNavigation();

            // Add States classes
            this.el.classList.add('has-3-slides');

            if (this.slidesCount == 2) {
                this.el.classList.add('has-2-slides');
                this.el.classList.remove('has-3-slides');
            }

            if (this.slidesCount == 1) {
                this.el.classList.add('has-1-slide');
                this.el.classList.remove('has-3-slides');
            }
        }
    }

    hideNavigation() {
        const nav = this.el.querySelector('.slider-nav');
        if (nav) {
            nav.style.display = 'none';
        }
    }
}
